// The Eigenbloom look's shape picker on the River: the shapes the tunnel can draw, as small
// inline-SVG outlines on a glass panel (the visual itself is the page's backdrop).
import { useEffect, useState } from "react";
import { useSettings } from "../ui/settings";
import { eigenbloomModule } from "./EigenbloomBackdrop";
import { enterImmersive } from "./immersive";

type Module = Awaited<ReturnType<typeof eigenbloomModule>>;

export function EigenbloomShapes() {
  const [mod, setMod] = useState<Module | null>(null);
  const shape = useSettings((s) => s.shape);
  const setShape = useSettings((s) => s.setShape);
  useEffect(() => {
    let alive = true;
    void eigenbloomModule()
      .then((m) => alive && setMod(m))
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  if (!mod) return null;
  return (
    <section className="eigenbloom-shapes glass" aria-label="Eigenbloom: the Harmonic Tunnel">
      <div className="row eigenbloom-shapes-head">
        <p className="eigenbloom-caption">The Harmonic Tunnel · drawn by the notes · pick its shape</p>
        <button
          type="button"
          className="btn btn-small eigenbloom-fullscreen"
          onClick={enterImmersive}
          data-testid="eigenbloom-fullscreen"
        >
          ⛶ Full screen
        </button>
      </div>
      <div className="shape-picker" role="radiogroup" aria-label="Shape the tunnel draws">
        {mod.shapes.map((s) => (
          <button
            key={s.id}
            type="button"
            role="radio"
            aria-checked={shape === s.id}
            aria-label={s.name}
            title={s.name}
            onClick={() => setShape(s.id)}
          >
            <svg viewBox="0 0 28 28" aria-hidden="true">
              <path
                d={mod.shapePath(s.id, 28)}
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        ))}
      </div>
    </section>
  );
}
